import React, { useEffect, useState, useRef } from "react";
import './Monetize.css'
import StandardServicesLogo from './../../../images/standardservicesstar.png'
import YoutubeMonetize1 from './../../../images/youtubemonetizeimg1.png'
import YoutubeMonetize2 from './../../../images/youtubemonetizeimg2.png'
import Select from 'react-select'
import YoutubeMonetizeBanner2 from './../../../images/ytmonetizebanner2.png'
import YotubeMonetizeBackIcon from './../../../images/ytmonetizebackicon.png'
import YotubeMonetizeImg1 from './../../../images/ytmonetizeimg1.png'
import YotubeMonetizeImg2 from './../../../images/ytmonetizeimg2.png'
import YotubeMonetizeImg3 from './../../../images/ytmonetizeimg3.png'
import YotubeMonetizeImg4 from './../../../images/ytmonetizeimg4.png'
import YotubeMonetizeImg5 from './../../../images/ytmonetizeimg5.png'
import YotubeMonetizeImg6 from './../../../images/ytmonetizeimg6.png'
import YotubeMonetizePoint from './../../../images/ytmonetizedrawerarrow.png'
import YotubeMonetizedots from './../../../images/ytmonetizebanner2dots.png'
import YotubeMonetizedots2 from './../../../images/ytmonetizebanner2dots2.png'
import YotubeMonetizebanner3dash from './../../../images/ytmonetizebanner3dashhori.png'
import YotubeMonetizebanner3ver from './../../../images/ytmonetizebanner3dasvert.png'
import YotubeMonetize000 from './../../../images/ytmonetize000.png'
import YotubeMonetizebl000 from './../../../images/ytmonetizebl000.png'
import YotubeMonetizebanner3gdash from './../../../images/ytmonetizebanner3gdashhori.png'
import YotubeMonetizebanner4vdash from './../../../images/ytmonetizebanner4vertline.png'
import YotubeMonetizebanner6vdash from './../../../images/ytmonetizebanner6vert.png'
import YotubeMonetizebanner6hdash from './../../../images/ytmonetizebanner6hori.png'
import { hover } from "@testing-library/user-event/dist/hover";
import { Link, useNavigate } from 'react-router-dom'
import Footer from "../../Footer/Footer";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';

function Monetize() {
    const [formView, setFormView] = useState(false)
    const navigate = useNavigate()
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const cookies = new Cookies(null, { path: '/' });
    const hasLogged = useRef(false);

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const handleResize = () => {
        // console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    useEffect(() => {
        topFunction()
        window.addEventListener("resize", handleResize, false);
        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "UGC Page", { "desc": "User opened the ugc page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "UGC Page", { "desc": "User opened the ugc page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "UGC Page", { "desc": "User opened the ugc page" })
                hasLogged.current = true;
            }
        }
    }, [])


    return (


        <div style={{ display: 'flex', flexDirection: 'column' }}>

            {/* ******************************************** */}


            {/* DESKTOP VIEW */}

            {
                dimensions.width >= 1024 &&
                <div>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/hbu0v0v94kprq5vvbl6c")`,
                        height: '31.75em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}

                    >
                        <div className="MaximizeEarnings">Maximize Your YouTube Earnings</div>
                        <div className="UgcAndRights">ugc and rights management</div>
                        <div style={{ height: '0.45em', width: '1.58em', backgroundColor: '#E91353', marginTop: '1em', marginBottom: '1em' }} />
                        <div className="TurnYour">Turn your YouTube views into revenue with our seamless monetization service.</div>
                        <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em' }} onClick={() => navigate('/support')}>
                            Get in Touch
                            <div className="PostLoginBtnOverlay" />
                        </div>
                        <div style={{
                            backgroundImage: `url(${YoutubeMonetizeBanner2})`,
                            height: '12.73em',
                            // height:'50px',
                            width: '100%',
                            backgroundSize: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'absolute',
                            bottom: '-8em',
                            marginTop: '0em',
                            overflow: 'hidden'
                            //  transform: `translate(0%, ${positionY}px)`
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}
                        >
                            <div style={{ position: 'absolute', width: '0.8em', height: '1em', top: '0em', left: '0em', backgroundColor: '#4CFFBE', clipPath: 'polygon(0 0, 100% 85%, 100% 100%, 0% 100%)' }} />
                            <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '1em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        </div>
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        height: '21.56em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        <div className="TheMostPowerfulUGC" style={{ position: 'relative' }}>
                            The Most Powerful UGC and Rights Management<br /> Service and Platform in the Industry.
                            <img src={YotubeMonetizedots2} style={{ position: 'absolute', top: '0em', width: '6.93em', height: '3.25em', left: '-4em' }} />
                            <img src={YotubeMonetizedots} style={{ position: 'absolute', top: '0em', left: '0em', width: '100%', height: '5.76em' }} />
                        </div>




                        <div
                            style={{
                                backgroundColor: '#0F1923',
                                position: 'absolute',
                                bottom: '-1em',
                                right: '0em',
                                width: '15.206em',
                                height: '2.79em',
                                clipPath: 'polygon(13% 0, 100% 0, 100% 100%, 0% 100%)'
                            }}
                        />
                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        // height:'50px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        paddingBottom: '4.6em'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner3ver} style={{ position: 'absolute', left: '1%' }} />
                        <div style={{ position: 'absolute', width: '0.8em', height: '15em', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />

                        <div style={{ display: 'flex', flexDirection: 'row', paddingTop: '5em', paddingBottom: '5em', width: '80%', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>

                                <div className="TransformYourContent">Transform Your Content into Revenue Seamlessly</div>
                                <img src={YotubeMonetizebanner3dash} style={{ width: '18.09em', height: '0.27em', marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="WithYOutubeMonetization">With YouTube Monetization Service, you can easily monetize your YouTube videos. Our platform identifies and claims unauthorized uses of your content, ensuring you get paid. We provide detailed analytics to track your performance and offer global reach to expand your audience. Focus on creating great content while we handles the monetization and rights management.</div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em' }}>
                                    <div style={{ width: '0.215em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                    <div style={{ width: '1.24em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg1} style={{ maxWidth: '33.54em', width: '50%', height: '33.75em', marginLeft: '0.95em' }} />

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', width: '64.5em', marginTop: '2.5em', paddingBottom: '2em', marginBottom: '2em', position: 'relative' }}>
                            <img src={YotubeMonetize000} style={{ marginRight: '3em' }} />
                            <div className="OurSolutions">Our Solutions</div>
                            <img src={YotubeMonetizebanner3gdash} style={{ position: 'absolute', bottom: '0em' }} />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg2} style={{ marginRight: '3em' }} />

                            <div>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> UGC and Rights Management</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer">
                                        The most powerful user-generated content and rights management service in the industry. We ensure that all your creative works are protected and monetized efficiently.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '0em' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em' }}>


                            <div>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Content ID and Optimization</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ paddingRight: '3em', paddingTop: '1em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        Deliver your music to an extensive range of platforms. Our global team actively monitors and optimizes your content to ensure all policies and settings are in place to claim and monetize your music.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg3} style={{ marginLeft: '3em' }} />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg4} style={{ marginRight: '3em' }} />

                            <div>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Trends and Reporting</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" styl={{ paddingTop: '0em', paddingRight: '5em' }}>
                                        Unlock detailed analytics through our portal. Set up custom reports and make critical comparisons between different digital service providers, enabling deeper analysis and strategic decision-making.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '0em' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em', zIndex: '2' }}>


                            <div>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Enhanced Services</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ paddingRight: '3em', paddingTop: '1em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        We offer enhanced UGC monetization and rights management services, empowering rights holders with industry-leading technology and support from our team of content experts.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg5} style={{ marginLeft: '3em' }} />
                        </div>

                    </div>

                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gduqr3xqmkgpihbdvjbo")`,
                        backgroundColor: 'rgba(255,255,255,60%)',
                        height: '37.66em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner4vdash} style={{ position: 'absolute', left: '1%', height: '100%' }} />

                        <div style={{
                            display: 'flex', flexDirection: 'row', alignItems: 'center'
                            , width: '66em'
                            , marginTop: '5em', position: 'relative', paddingBottom: '1em', marginLeft: '3em'
                        }}>
                            <img src={YotubeMonetizebl000} style={{ width: '1em', height: '2em', marginRight: '2em' }} />
                            <div className="WhyAdrev">Why Us?</div>
                            <div style={{ width: '19em', height: '3px', backgroundColor: '#4CFFBE', position: 'absolute', bottom: '0em' }} />
                        </div>





                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '4em', position: 'relative', width: '70%', justifyContent: 'center' }}>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader">In-House Expertise and Technology</div>
                                <div className="AdrevDesc">Our claims team utilizes proprietary audio detection technology to identify and claim additional uses of sound recordings, ensuring you never miss out on potential revenue.</div>
                            </div>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader">Multi-Channel Network Management</div>
                                <div className="AdrevDesc">We partner with clients to manage their YouTube channels, boosting viewership, enhancing content discovery, and increasing video earnings through our exclusive Music Multi-Channel Network.</div>
                            </div>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader">Pioneering Claim Management and Licensing</div>
                                <div className="AdrevDesc">Utilize our premium claim management tool to handle complex claims, issue microsync licenses, and programmatically release claims on licensed content, all supported by a team specialized in revenue optimization in the YouTube ecosystem.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', top: '16em' }}>
                                <div style={{ width: '0.28em', height: '2.34em', backgroundColor: '#0F1923', marginRight: '0.625em' }} />
                                <div style={{ width: '1.6em', height: '2.34em', backgroundColor: '#0F1923' }} />
                            </div>
                        </div>

                        <div style={{ width: '60%', height: '2.79em', backgroundColor: '#0F1923', bottom: '-1em', left: '0', position: 'absolute', clipPath: ' polygon(0 0, 95% 0, 100% 100%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }} />



                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        height: '35.125em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={YotubeMonetizebanner6vdash} style={{ position: 'absolute', left: '1%', bottom: '0', zIndex: '1' }} />

                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '7.87em', zIndex: '2' }}>
                            <img src={YotubeMonetizeImg6} style={{ marginRight: '1.5em' }} />
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div className="Readytoboost">
                                    Ready to Boost Your YouTube Revenue?
                                </div>

                                <img src={YotubeMonetizebanner6hdash} style={{ marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="maximizeYoutubeEarnings">
                                    Maximize your YouTube earnings with us. Our expert team and advanced technology make monetization simple. Start optimizing your revenue today.
                                </div>

                                <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em' }} onClick={() => { navigate('/support') }}>
                                    Get in Touch
                                    <div className="PostLoginBtnOverlay" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            }

            {/* ******************************************** */}
            {/* TABLET VIEW */}

            {
                dimensions.width >= 768 && dimensions.width < 1024 &&
                <div>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/hbu0v0v94kprq5vvbl6c")`,
                        height: '31.75em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}

                    >
                        <div className="MaximizeEarnings">Maximize Your YouTube Earnings</div>
                        <div className="UgcAndRights">ugc and rights management</div>
                        <div style={{ height: '0.45em', width: '1.58em', backgroundColor: '#E91353', marginTop: '1em', marginBottom: '1em' }} />
                        <div className="TurnYour">Turn your YouTube views into revenue with our seamless monetization service.</div>
                        <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em' }} onClick={() => navigate('/support')}>
                            Get in Touch
                            <div className="PostLoginBtnOverlay" />
                        </div>
                        <div style={{
                            backgroundImage: `url(${YoutubeMonetizeBanner2})`,
                            height: '12.73em',
                            // height:'50px',
                            width: '100%',
                            backgroundSize: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'absolute',
                            bottom: '-8em',
                            marginTop: '0em',
                            overflow: 'hidden'
                            //  transform: `translate(0%, ${positionY}px)`
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}
                        >
                            <div style={{ position: 'absolute', width: '0.8em', height: '1em', top: '0em', left: '0em', backgroundColor: '#4CFFBE', clipPath: 'polygon(0 0, 100% 85%, 100% 100%, 0% 100%)' }} />
                            <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '1em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        </div>
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        height: '21.56em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        <div className="TheMostPowerfulUGC" style={{ position: 'relative' }}>
                            The Most Powerful UGC and Rights Management<br /> Service and Platform in the Industry.
                            <img src={YotubeMonetizedots2} style={{ position: 'absolute', top: '0em', width: '6.93em', height: '3.25em', left: '-4em' }} />
                            <img src={YotubeMonetizedots} style={{ position: 'absolute', top: '0em', left: '0em', width: '100%', height: '5.76em' }} />
                        </div>




                        <div
                            style={{
                                backgroundColor: '#0F1923',
                                position: 'absolute',
                                bottom: '-1em',
                                right: '0em',
                                width: '15.206em',
                                height: '2.79em',
                                clipPath: 'polygon(13% 0, 100% 0, 100% 100%, 0% 100%)'
                            }}
                        />
                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        // height:'50px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        paddingBottom: '4.6em'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner3ver} style={{ position: 'absolute', left: '1%' }} />
                        <div style={{ position: 'absolute', width: '0.8em', height: '15em', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />

                        <div style={{ display: 'flex', flexDirection: 'row', paddingTop: '5em', paddingBottom: '5em', width: '90%', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', width: '50%' }}>

                                <div className="TransformYourContent" style={{ width: '80%' }}>Transform Your Content into Revenue Seamlessly</div>
                                <img src={YotubeMonetizebanner3dash} style={{ width: '18.09em', height: '0.27em', marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="WithYOutubeMonetization" style={{ width: '80%' }}>With YouTube Monetization Service, you can easily monetize your YouTube videos. Our platform identifies and claims unauthorized uses of your content, ensuring you get paid. We provide detailed analytics to track your performance and offer global reach to expand your audience. Focus on creating great content while we handles the monetization and rights management.</div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em' }}>
                                    <div style={{ width: '0.215em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                    <div style={{ width: '1.24em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg1} style={{ maxWidth: '33.54em', width: '50%', height: '33.75em', marginLeft: '0.95em' }} />

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', width: '90%', marginTop: '2.5em', paddingBottom: '2em', marginBottom: '2em', position: 'relative' }}>
                            <img src={YotubeMonetize000} style={{ marginRight: '3em' }} />
                            <div className="OurSolutions">Our Solutions</div>
                            <img src={YotubeMonetizebanner3gdash} style={{ position: 'absolute', bottom: '0em' }} />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em', width: '100%' }}>
                            <img src={YotubeMonetizeImg2} style={{ marginRight: '1em', aspectRatio: '1.5', width: '40%' }} />

                            <div style={{ width: '50%' }}>
                                <span className="DrawerTitle"><span style={{ color: '#4CFFBE' }}>\\</span> UGC and Rights Management</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer">
                                        The most powerful user-generated content and rights management service in the industry. We ensure that all your creative works are protected and monetized efficiently.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '0em' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em' }}>


                            <div style={{ width: '50%' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Content ID and Optimization</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ paddingRight: '3em', paddingTop: '0em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        Deliver your music to an extensive range of platforms. Our global team actively monitors and optimizes your content to ensure all policies and settings are in place to claim and monetize your music.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg3} style={{ marginLeft: '1em', aspectRatio: '1.5', width: '40%' }} />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg4} style={{ marginRight: '1em', aspectRatio: '1.5', width: '40%' }} />

                            <div style={{ width: '50%' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Trends and Reporting</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" styl={{ paddingTop: '1em', paddingRight: '5em' }}>
                                        Unlock detailed analytics through our portal. Set up custom reports and make critical comparisons between different digital service providers, enabling deeper analysis and strategic decision-making.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '0em' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '3em', zIndex: '2' }}>


                            <div style={{ width: '50%' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Enhanced Services</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ paddingRight: '3em', paddingTop: '0em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        We offer enhanced UGC monetization and rights management services, empowering rights holders with industry-leading technology and support from our team of content experts.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <img src={YotubeMonetizeImg5} style={{ marginLeft: '1em', aspectRatio: '1.5', width: '40%' }} />
                        </div>

                    </div>

                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gduqr3xqmkgpihbdvjbo")`,
                        backgroundColor: 'rgba(255,255,255,60%)',
                        height: '37.66em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner4vdash} style={{ position: 'absolute', left: '1%', height: '100%' }} />

                        <div style={{
                            display: 'flex', flexDirection: 'row', alignItems: 'center'
                            , width: '90%'
                            , marginTop: '5em', position: 'relative', paddingBottom: '1em', marginLeft: '10%'
                        }}>
                            <img src={YotubeMonetizebl000} style={{ width: '1em', height: '2em', marginRight: '2em' }} />
                            <div className="WhyAdrev">Why Us?</div>
                            <div style={{ width: '19em', height: '3px', backgroundColor: '#4CFFBE', position: 'absolute', bottom: '0em' }} />
                        </div>





                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '4em', position: 'relative', width: '90%', justifyContent: 'center' }}>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>In-House Expertise and Technology</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>Our claims team utilizes proprietary audio detection technology to identify and claim additional uses of sound recordings, ensuring you never miss out on potential revenue.</div>
                            </div>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>Multi-Channel Network Management</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>We partner with clients to manage their YouTube channels, boosting viewership, enhancing content discovery, and increasing video earnings through our exclusive Music Multi-Channel Network.</div>
                            </div>
                            <div style={{ marginRight: '1.5em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>Pioneering Claim Management and Licensing</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>Utilize our premium claim management tool to handle complex claims, issue microsync licenses, and programmatically release claims on licensed content, all supported by a team specialized in revenue optimization in the YouTube ecosystem.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', bottom: '-2em' }}>
                                <div style={{ width: '0.28em', height: '2.34em', backgroundColor: '#0F1923', marginRight: '0.625em' }} />
                                <div style={{ width: '1.6em', height: '2.34em', backgroundColor: '#0F1923' }} />
                            </div>
                        </div>

                        <div style={{ width: '60%', height: '2.79em', backgroundColor: '#0F1923', bottom: '-1em', left: '0', position: 'absolute', clipPath: ' polygon(0 0, 95% 0, 100% 100%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }} />



                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        height: '35.125em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={YotubeMonetizebanner6vdash} style={{ position: 'absolute', left: '1%', bottom: '0', zIndex: '1' }} />

                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '7.87em', zIndex: '2' }}>
                            <img src={YotubeMonetizeImg6} style={{ marginRight: '1.5em', aspectRatio: '1.6', width: '40%', paddingLeft: '2em' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                                <div className="Readytoboost" style={{ width: '100%' }}>
                                    Ready to Boost Your YouTube Revenue?
                                </div>

                                <img src={YotubeMonetizebanner6hdash} style={{ marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="maximizeYoutubeEarnings" style={{ width: '90%' }}>
                                    Maximize your YouTube earnings with us. Our expert team and advanced technology make monetization simple. Start optimizing your revenue today.
                                </div>

                                <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em' }} onClick={() => { navigate('/support') }}>
                                    Get in Touch
                                    <div className="PostLoginBtnOverlay" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            }

            {/* ******************************************** */}
            {/* MOBILE VIEW */}

            {
                dimensions.width < 768 &&
                <div style={{ overflow: 'hidden' }}>
                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/hbu0v0v94kprq5vvbl6c")`,
                        height: '31.75em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}

                    >
                        <div className="MaximizeEarnings">Maximize Your YouTube Earnings</div>
                        <div className="UgcAndRights">ugc and rights management</div>
                        <div style={{ height: '0.45em', width: '1.58em', backgroundColor: '#E91353', marginTop: '1em', marginBottom: '1em' }} />
                        <div className="TurnYour">Turn your YouTube views into revenue with our seamless monetization service.</div>
                        <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em' }} onClick={() => navigate('/support')}>
                            Get in Touch
                            <div className="PostLoginBtnOverlay" />
                        </div>
                        <div style={{
                            backgroundImage: `url(${YoutubeMonetizeBanner2})`,
                            height: '12.73em',
                            // height:'50px',
                            width: '100%',
                            backgroundSize: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            position: 'absolute',
                            bottom: '-8em',
                            marginTop: '0em',
                            overflow: 'hidden'
                            //  transform: `translate(0%, ${positionY}px)`
                            // lineHeight:'0px',
                            // margin:'0px',
                            // padding:'0px',
                            // flex:'1'
                        }}
                        >
                            <div style={{ position: 'absolute', width: '0.8em', height: '1em', top: '0em', left: '0em', backgroundColor: '#4CFFBE', clipPath: 'polygon(0 0, 100% 85%, 100% 100%, 0% 100%)' }} />
                            <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '1em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        </div>
                    </div>

                    <div style={{
                        backgroundColor: '#DFDFDE',
                        height: '21.56em',
                        // height:'50px',
                        width: '100%',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <div style={{ position: 'absolute', width: '0.8em', height: '100%', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />
                        <div className="TheMostPowerfulUGC" style={{ position: 'relative' }}>
                            The Most Powerful UGC and Rights Management<br /> Service and Platform in the Industry.
                            <img src={YotubeMonetizedots2} style={{ position: 'absolute', top: '1em', width: '6.93em', height: '3.25em', left: '-4em' }} />
                            <img src={YotubeMonetizedots} style={{ position: 'absolute', top: '1em', left: '0em', width: '100%', height: '5.76em' }} />
                        </div>




                        <div
                            style={{
                                backgroundColor: '#0F1923',
                                position: 'absolute',
                                bottom: '-1em',
                                right: '0em',
                                width: '15.206em',
                                height: '2.79em',
                                clipPath: 'polygon(13% 0, 100% 0, 100% 100%, 0% 100%)'
                            }}
                        />
                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        // height:'50px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        paddingBottom: '4.6em'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner3ver} style={{ position: 'absolute', left: '1%' }} />
                        <div style={{ position: 'absolute', width: '0.8em', height: '15em', top: '0em', left: '0em', backgroundColor: '#4CFFBE' }} />

                        <img src={YotubeMonetizeImg1} style={{ width: '90%', aspectRatio: '1', marginLeft: '0.95em', marginTop: '1em' }} />

                        <div style={{ display: 'flex', flexDirection: 'row', paddingTop: '5em', paddingBottom: '5em', width: '80%', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', position: 'relative', width: '80%' }}>

                                <div className="TransformYourContent" style={{ fontSize: '2.5rem' }}>Transform Your Content into Revenue Seamlessly</div>
                                <img src={YotubeMonetizebanner3dash} style={{ width: '18.09em', height: '0.27em', marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="WithYOutubeMonetization" style={{ width: '90%' }}>With YouTube Monetization Service, you can easily monetize your YouTube videos. Our platform identifies and claims unauthorized uses of your content, ensuring you get paid. We provide detailed analytics to track your performance and offer global reach to expand your audience. Focus on creating great content while we handles the monetization and rights management.</div>

                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em', overflow: 'hidden' }}>
                                    <div style={{ width: '0.215em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                    <div style={{ width: '1.24em', height: '1.72em', backgroundColor: '#E91353', marginRight: '0.625em' }} />
                                </div>
                            </div>



                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', width: '90%', marginTop: '2.5em', paddingBottom: '2em', marginBottom: '2em', position: 'relative' }}>
                            <img src={YotubeMonetize000} style={{ marginRight: '2em' }} />
                            <div className="OurSolutions">Our Solutions</div>
                            <img src={YotubeMonetizebanner3gdash} style={{ position: 'absolute', bottom: '0em' }} />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg2} />

                            <div style={{ width: '80%', marginTop: '1em' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> UGC and Rights Management</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ width: '95%' }}>
                                        The most powerful user-generated content and rights management service in the industry. We ensure that all your creative works are protected and monetized efficiently.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '1em', overflow: 'hidden' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg3} />

                            <div style={{ width: '80%', marginTop: '1em' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Content ID and Optimization</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ width: '95%', paddingRight: '3em', paddingTop: '0em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        Deliver your music to an extensive range of platforms. Our global team actively monitors and optimizes your content to ensure all policies and settings are in place to claim and monetize your music.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em', overflow: 'hidden' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '3em' }}>
                            <img src={YotubeMonetizeImg4} />

                            <div style={{ width: '80%', marginTop: '1em' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Trends and Reporting</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ width: '95%', paddingTop: '0em', paddingRight: '5em' }}>
                                        Unlock detailed analytics through our portal. Set up custom reports and make critical comparisons between different digital service providers, enabling deeper analysis and strategic decision-making.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', right: '1em', overflow: 'hidden' }}>
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginLeft: '0.5em' }} />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '3em', zIndex: '2' }}>
                            <img src={YotubeMonetizeImg5} />

                            <div style={{ width: '80%', marginTop: '1em' }}>
                                <span className="DrawerTitle" ><span style={{ color: '#4CFFBE' }}>\\</span> Enhanced Services</span>

                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '2em' }}>
                                    <img src={YotubeMonetizePoint} style={{ width: '2.36em', height: '2.36em', marginRight: '-1em' }} />
                                    <div className="DrawerContainer" style={{ width: '95%', paddingRight: '3em', paddingTop: '0em', clipPath: 'polygon(0 0, 95% 0, 100% 46%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }}>
                                        We offer enhanced UGC monetization and rights management services, empowering rights holders with industry-leading technology and support from our team of content experts.
                                        <div style={{ display: "flex", flexDirection: 'row', position: 'absolute', bottom: '0em', left: '0em', overflow: 'hidden' }}>
                                            <div className="div" style={{ width: '1.05em', height: '0.125em', marginRight: '0.5em' }} />
                                            <div className="div" style={{ width: '13.07em', height: '0.125em' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                    <div style={{
                        backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/gduqr3xqmkgpihbdvjbo")`,
                        backgroundColor: 'rgba(255,255,255,60%)',
                        // height:'45.66em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        paddingTop: '3em',
                        paddingBottom: '3em'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>
                        <img src={YotubeMonetizebanner4vdash} style={{ position: 'absolute', left: '1%', height: '100%' }} />

                        <div style={{
                            display: 'flex', flexDirection: 'row', alignItems: 'center'
                            , width: '90%'
                            , marginTop: '5em', position: 'relative', paddingBottom: '1em', marginLeft: '10%'
                        }}>
                            <img src={YotubeMonetizebl000} style={{ width: '1em', height: '2em', marginRight: '2em' }} />
                            <div className="WhyAdrev">Why Us?</div>
                            <div style={{ width: '19em', height: '3px', backgroundColor: '#4CFFBE', position: 'absolute', bottom: '0em' }} />
                        </div>





                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '4em', position: 'relative', width: '90%', justifyContent: 'center' }}>
                            <div style={{ marginRight: '1.5em', marginBottom: '2em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>In-House Expertise and Technology</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>Our claims team utilizes proprietary audio detection technology to identify and claim additional uses of sound recordings, ensuring you never miss out on potential revenue.</div>
                            </div>
                            <div style={{ marginRight: '1.5em', marginBottom: '2em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>Multi-Channel Network Management</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>We partner with clients to manage their YouTube channels, boosting viewership, enhancing content discovery, and increasing video earnings through our exclusive Music Multi-Channel Network.</div>
                            </div>
                            <div style={{ marginRight: '1.5em', marginBottom: '2em' }}>
                                <div className="AdrevHeader" style={{ width: '90%' }}>Pioneering Claim Management and Licensing</div>
                                <div className="AdrevDesc" style={{ width: '90%' }}>Utilize our premium claim management tool to handle complex claims, issue microsync licenses, and programmatically release claims on licensed content, all supported by a team specialized in revenue optimization in the YouTube ecosystem.</div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', position: 'absolute', bottom: '-2em' }}>
                                <div style={{ width: '0.28em', height: '2.34em', backgroundColor: '#0F1923', marginRight: '0.625em' }} />
                                <div style={{ width: '1.6em', height: '2.34em', backgroundColor: '#0F1923' }} />
                            </div>
                        </div>


                        <div style={{ width: '60%', height: '2.79em', backgroundColor: '#0F1923', bottom: '-1em', left: '0', position: 'absolute', clipPath: ' polygon(0 0, 95% 0, 100% 100%, 100% 100%, 100% 100%, 0 100%, 0 100%, 0 0)' }} />



                    </div>

                    <div style={{
                        backgroundColor: '#0F1923',
                        // height:'38.125em',
                        paddingTop: '3em',
                        paddingBottom: '3em',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        paddingLeft: '4em'
                        //  transform: `translate(0%, ${positionY}px)`
                        // lineHeight:'0px',
                        // margin:'0px',
                        // padding:'0px',
                        // flex:'1'
                    }}>

                        <img src={YotubeMonetizebanner6vdash} style={{ position: 'absolute', left: '1%', bottom: '0', zIndex: '1' }} />

                        <div style={{ display: 'flex', flexDirection: 'column', zIndex: '2' }}>
                            <img src={YotubeMonetizeImg6} style={{ aspectRatio: '1.67', width: '75%' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                <div className="Readytoboost" style={{ width: '100%' }}>
                                    Ready to Boost Your YouTube Revenue?
                                </div>

                                <img src={YotubeMonetizebanner6hdash} style={{ marginTop: '1.5em', marginBottom: '1.5em' }} />
                                <div className="maximizeYoutubeEarnings" style={{ width: '90%' }}>
                                    Maximize your YouTube earnings with us. Our expert team and advanced technology make monetization simple. Start optimizing your revenue today.
                                </div>

                                <div className="GetInTouchBtnPrelogin" style={{ paddingTop: '0.8em', paddingBottom: '0.8em', width: '80%' }} onClick={() => { navigate('/support') }}>
                                    Get in Touch
                                    <div className="PostLoginBtnOverlay" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            }



        </div>
    );
}

export default Monetize;